import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'

import PageTitle from './PageTitle'
import AssignManagerButton from './AssignManagerButton'
import AssignManagerDialog from './AssignManagerDialog'
import SuperUserButton from './SuperUserButton'
import PrevNextButton from './PrevNextButton'
import Header from './Header'
import TabMenu from './TabMenu'
import TabProjectDetails from './TabProjectDetails'
import TabPitchSummary from './TabPitchSummary'
import TabQuotationPO from './TabQuotationPO'
import TabTaskList from './TabTaskList'
import TabInvoice from './TabInvoice'
import TabRatingReview from './TabRatingReview'

const Detail = props => (
  <div className="page-content">
    {props.isLoading && <Loading />}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle name={props.order.name} />
      <AssignManagerButton onClick={() => props.toggleManagerDialog(true)}>
        Assign Project manager
      </AssignManagerButton>

      <SuperUserButton
        func={props.goesTopPlatform(
          props.clientProfileId,
          props.admin.email,
          `project/${props.order.id}/order?tab=brief`,
          'project'
        )}
        label="Edit Project Settings"
      />

      <SuperUserButton
        func={props.goesTopPlatform(
          props.clientProfileId,
          props.admin.email,
          `project/${props.order.id}/order`,
          'project'
        )}
      />

      <PrevNextButton prevId={props.prevId} nextId={props.nextId} />
    </div>
    {props.order.status === 3 &&
      props.projectInvoices.length &&
      props.projectInvoices[0].status === 1 && (
        <div>You need to confirm invoice to start this project.</div>
      )}
    <Header
      handleCompleteProject={props.handleCompleteProject}
      handleApprovedProject={props.handleApprovedProject}
    />
    <TabMenu />
    <div className="row margin-bottom-20">
      {props.tabActive === 0 && (
        <TabProjectDetails handleSubmitComment={props.handleSubmitComment} />
      )}
      {props.tabActive === 1 && <TabPitchSummary />}
      {props.tabActive === 2 && (
        <TabQuotationPO
          quotationContent={props.quotationContent}
          poContent={props.poContent}
          poPendingValue={props.poPendingValue}
          handleActionPo={props.handleActionPo}
          poApprovedValue={props.poApprovedValue}
          poRejectedValue={props.poRejectedValue}
          order={props.order}
          handelActionInvoice={props.handelActionInvoice}
          restrictFields={props.restrictFields}
        />
      )}
      {props.tabActive === 3 && (
        <TabInvoice
          generateTaxInvoice={props.generateTaxInvoice}
          generatePaymentSlip={props.generatePaymentSlip}
          selectedCreators={props.selectedCreators}
        />
      )}
      {props.tabActive === 4 && <TabTaskList />}
      {props.tabActive === 5 && <TabRatingReview />}
    </div>
    <AssignManagerDialog />
  </div>
)

Detail.defaultProps = {
  goesTopPlatform: () => {},
}

Detail.propTypes = {
  goesTopPlatform: PropTypes.func,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    manager: PropTypes.object,
  }).isRequired,
  projectInvoices: PropTypes.arrayOf(PropTypes.object).isRequired,
  quotationContent: PropTypes.arrayOf(PropTypes.array).isRequired,
  poContent: PropTypes.arrayOf(PropTypes.array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleActionPo: PropTypes.func.isRequired,
  handleCompleteProject: PropTypes.func.isRequired,
  handleSubmitComment: PropTypes.func.isRequired,
  poPendingValue: PropTypes.number.isRequired,
  poApprovedValue: PropTypes.number.isRequired,
  poRejectedValue: PropTypes.number.isRequired,
  prevId: PropTypes.string.isRequired,
  nextId: PropTypes.string.isRequired,
  tabActive: PropTypes.number.isRequired,
  generateTaxInvoice: PropTypes.func.isRequired,
  generatePaymentSlip: PropTypes.func.isRequired,
  selectedCreators: PropTypes.arrayOf(PropTypes.object).isRequired,
  handelActionInvoice: PropTypes.func.isRequired,
  restrictFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  admin: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  clientProfileId: PropTypes.string.isRequired,
}

export default Detail
